import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { CalculatorRateBarSkeleton } from "web_myplann/Calculators/Components/CalculatorRateBarSkeleton";
import { CalculatorResultSkeletonRow } from "web_myplann/Calculators/Components/CalculatorResultSkeletonRow";
import { CalculatorResultSurface } from "web_myplann/Calculators/Components/CalculatorResultSurface";

export const CalculatorResultSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<CalculatorResultSurface>
			<Skeleton
				variant="rounded"
				width={148}
				height={24}
				animation="wave"
				sx={{ borderRadius: theme.radii.full, mb: theme.spacingTokens.md }}
			/>
			<Skeleton variant="rounded" width={200} height={24} animation="wave" />
			<Stack mt={theme.spacingTokens.lg} gap={theme.spacingTokens.sm}>
				<CalculatorResultSkeletonRow />
				<CalculatorResultSkeletonRow />
			</Stack>
			<Stack
				mt={theme.spacingTokens.lg}
				pt={theme.spacingTokens.lg}
				gap={theme.spacingTokens.sm}
				borderTop={theme.colors.border.solid(theme.hero.divider)}
			>
				<Skeleton variant="text" width={160} height={20} animation="wave" />
				<CalculatorRateBarSkeleton />
				<CalculatorRateBarSkeleton />
				<CalculatorRateBarSkeleton />
			</Stack>
			<Stack
				mt={theme.spacingTokens.lg}
				pt={theme.spacingTokens.lg}
				alignItems="center"
				borderTop={theme.colors.border.solid(theme.hero.divider)}
			>
				<Skeleton variant="text" width="70%" height={16} animation="wave" />
			</Stack>
			<Skeleton
				variant="rounded"
				height={48}
				animation="wave"
				sx={{ mt: theme.spacingTokens.sm, borderRadius: theme.radii.xl }}
			/>
		</CalculatorResultSurface>
	);
};
